import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import { ServiceService } from '../service.service';
declare var google: any;
import Swal from 'sweetalert2';


@Component({
  selector: 'app-detalhes',
  templateUrl: './detalhes.component.html',
  styleUrls: ['./detalhes.component.scss']
})
export class DetalhesComponent implements OnInit {

  id;

  formulario: any = {};

  model: any = {};

  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];



  constructor(
    private router: Router,
    private sanitizer: DomSanitizer,
    private _service: ServiceService,
    private metaService: Meta
  ) {
    const url = this.router.url;
    this.id = url.replace('/detalhes/', '');
  }

  ngOnInit() {
    this.initializeGallery();

    console.log('id', this.id);

    this._service.getById(this.id)
      .subscribe((data) => {
        console.log(data);
        this.model = data;
        this.addImagesGallery();
        this.myMap(this.model.maps);

        this.updateMeta()
        // const id = this.model.id;
        // const imagem = this.model.img_detalhes;
        // const url = `/admin/webroot/files/veiculos/${id}/${imagem}`;
        // Object.assign(this.model, { imgUrl: this.sanitizer.bypassSecurityTrustStyle('url(' + url + ')') });
      });
  }


  routerEvent(event) {
    /* this.router.navigate(['/vitrine']); */
    this.router.navigate([event]);

  }

  initializeGallery() {
    this.galleryOptions = [
      {
        width: '100%',
        height: '600px',
        thumbnailsColumns: 6,
        imageAnimation: NgxGalleryAnimation.Slide,
      },
      // max-width 800
      {
        breakpoint: 800,
        previewAnimation: false,
        width: '100%',
        height: '600px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20,
      },
      // max-width 400
      {
        breakpoint: 400,
        preview: true,
      }
    ];
  }

  addImagesGallery() {
    const images = [];
    const objeto = this.model.img_imoveis;
    const id = this.model.id;
    Object.keys(objeto).map(function (key, index) {
      images.push({
        small: 'http://www.vanguardacondominios.com.br/imobiliaria/admin/webroot/files/imoveis/' + id + '/' + objeto[key],
        medium: 'http://www.vanguardacondominios.com.br/imobiliaria/admin/webroot/files/imoveis/' + id + '/' + objeto[key],
        big: 'http://www.vanguardacondominios.com.br/imobiliaria/admin/webroot/files/imoveis/' + id + '/' + objeto[key]
      });
    });
    this.galleryImages = images;
    console.log('imglist', this.galleryImages);
  }

  myMap(local) {

    // const local = '-28.4051036,-54.9666907';
    let localMap = [];
    localMap = local.split(',');

    const myCenter = new google.maps.LatLng(localMap[0], localMap[1]);
    const mapProp = {
      center: myCenter,
      zoom: 16,
      scrollwheel: false,
      draggable: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    const map = new google.maps.Map(document.getElementById('googleMap'), mapProp);
    const marker = new google.maps.Marker({
      position: myCenter,
      icon: this.pinSymbol("rgb(0, 0, 68)"),
    });
    marker.setMap(map);
  }

  pinSymbol(color) {
    return {
      path: 'M-5 -35c5,-2 9,2 10,5 1,5 -2,9 -5,10 -10,3 -15,-12 -5,-15zm2 36c3,-2 7,-8 9,-11 2,-4 5,-7 6,-12 4,-12 -4,-22 -15,-22 -11,0 -19,10 -15,22 1,6 11,19 15,23z',
      fillColor: color,
      fillOpacity: 1,
      strokeColor: 'rgb(0, 0, 68)',
      strokeWeight: 1,
      scale: 1,
    };
  }

  enviarMensagem() {
    const f = this.formulario;
    console.log('formulario', f);
    if (f.nome == null || f.telefone == null || f.email == null || f.mensagem == null) {
      Swal('Oops...', 'Por favor preencha todos os campos do formulário antes de enviar', 'error');
      // alert('Por favor preencha todos os campos');
      return;
    }

    Swal('Aguarde...', 'Enviando mensagem!', 'success');
    // alert('Mensagem Enviada, retornaremos em breve!');
    this._service.sendmessage(this.formulario)
    .subscribe(data => {
      Swal('Enviado!', 'Mensagem enviada! Retornaremos o mais breve possível!', 'success');
      
      this.formulario = {
        nome: '',
        telefone: '',
        email: '',
        mensagem: '',
        referencia: this.model.id
      };
    });
  }

  // <meta property="og:url" content="http://www.vanguardacondominios.com.br/imobiliaria">
  // <meta property="og:image" content="http://www.vanguardacondominios.com.br/assets/img/splash.jpg">
  // <meta property="og:title" content="Imobiliária Vanguarda">
  updateMeta(){
    this.metaService.updateTag({ property: 'og:url', content: 'http://vanguardacondominios.com.br/imobiliaria/detalhes/164' });
    this.metaService.updateTag({ property: 'og:image', content: 'http://www.vanguardacondominios.com.br/imobiliaria/admin/webroot/files/imoveis/164/SalgadoFilho185centronorte1573390351583jpg.jpeg' });
    // this.metaService.updateTag({ property: 'og:title', content: siteTag.value });
    console.log('metaUPDATED')
  }

}

